import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import './app.css';
import CommandPalette from './components/core-ui/command-palette/command-palette';
import TerminalLauncher from './components/core-ui/terminal/terminal-launcher';
import BackToTop from './components/helper/back-to-top/back-to-top';
import RouteAnnouncer from './components/helper/route-announcer';
import ScrollProgress from './components/helper/scroll-progress';
import ScrollToTop from './components/helper/scroll-to-top';
import Spotlight from './components/helper/spotlight';
import { headerData } from './data/headerData';
import { HomePage, ProjectDetailPage, ProjectPage } from './pages';

const ResumePage = lazy(() => import('./pages/resume/index'));

function App() {
  return (
    <Router>
      <a className='skip-link' href='#main'>Skip to content</a>
      <CommandPalette />
      <TerminalLauncher />
      <ScrollProgress />
      <ScrollToTop />
      <Spotlight />
      <RouteAnnouncer />
      <Suspense fallback={null}>
      <Routes>
        <Route path='/' element={<HomePage />} exact />
        <Route path='/projects' element={<ProjectPage />} exact />
        <Route path='/projects/:slug' element={<ProjectDetailPage />} />
        <Route path='/resume' element={<ResumePage />} />
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
      </Suspense>
      <footer className='site-footer'>
        <div className='container'>
          <span>&copy; {new Date().getFullYear()} {headerData.name}</span>
          <span>Developed by {headerData.name}</span>
        </div>
      </footer>
      <BackToTop />
    </Router>
  );
}

export default App;
